export default function EmailTemplateSettings() {

    var EmailTemplate = function() {
        const _this = $(this);
        var instanceVars = {
            templates: [],
            oneClickEnabled: false,
            eDefer: null,
            initialise: function() {
                this.getTemplates();
                this.getSellerData();
                this.addListeners();
            },

            getSellerData: function() {
                var t = this;
                Bark.api(
                    'seller/self/',
                    {},
                    function (data) {
                        var sellerData = data.data;
                        t.isBillable = sellerData['is_billable'];
                        t.oneClickEnabled = sellerData['one_click_enabled'];
                    },
                    function (error) {
                        console.log(error);
                        bugsnagClient.notify(new Error('Seller self call failed'), {metaData: error});
                    },
                    'GET'
                );
            },

            getTemplates: function() {
                var t = this;
                Bark.emailService(
                    'user/templates/',
                    {},
                    function (data) {
                        t.templates = data.data;
                        t.redraw(data);
                    },
                    function (error) {
                        t.showGeneralError(_t("seller_settings_comms:email-templates.general-error"))
                    },
                    'GET'
                )
            },

            deleteModalHtml: function (isDefault) {
                if (isDefault && this.oneClickEnabled) {
                    return (
                        `<h4 class="text-center">${_t("seller_settings_comms:email-templates.delete-template.oneclick-confirm-label")}</h4> <p class="text-grey-600 text-center">${_t("seller_settings_comms:email-templates.delete-template.oneclick-text-1")}</p> <p class="text-grey-600 text-center mb-0">${_t("seller_settings_comms:email-templates.delete-template.oneclick-text-2")}</p>`
                    );
                } {
                    return  `<h4 class="text-center mb-0">${_t("seller_settings_comms:email-templates.delete-template.default-confirm-label")}</h4>`;
                }
            },

            deleteTemplate: function (e) {
                var t = this;
                var target = $(e.target);
                var templateRow = target.closest('.email-template-row');
                var isDefault = target.closest('.email-template-row').hasClass('default');
                var tid = +templateRow.data('id');
                if (tid) {
                    var modalElement = modalManager.quickModal(
                        '',
                        '',
                        t.deleteModalHtml(isDefault),
                        [
                            modalManager.cancelLinkHTML(),
                            `<button class="btn btn-danger submit modal-submit" type="button"><span class="submit-spinner spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="submit-text">${_t("seller_settings_comms:email-templates.delete-template.remove-button")}</span></button>`
                        ],
                        ['modal-sm']
                    );
                    modalElement.on(
                        'click',
                        '.modal-submit',
                        {},
                        function () {
                            modalElement.modal('hide');
                            $('.email-template-row[data-id="'+tid+'"]').addClass('waiting');
                            Bark.api(
                                'user/email-template/' + tid,
                                {'is_default': isDefault},
                                function () {
                                    t.getTemplates();
                                    modalElement.modal('hide');
                                    templateRow.remove();

                                }, function () {
                                    modalElement.modal('hide');
                                    $('.email-template-row[data-id="'+tid+'"]').removeClass('waiting');
                                    Bark.hideLoading();
                                }, 'DELETE');
                        }
                    );
                }
            },

            redraw: function(data) {
                var i;
                var templateData;
                var handleBarTemplate;

                var length = data.data.length;

                $('.email-template-list').html('');

                if (length === 0) {
                    $('.email-templates-container').removeClass('has-items');
                } else {
                    $('.email-templates-container').addClass('has-items');
                }

                for (i = 0; i < length; i++) {
                    templateData = data.data[i];
                    templateData['editLinkUrl'] = _l('/settings/template/' + templateData.id  + '/?src=et');
                    handleBarTemplate = Handlebars.compile(document.getElementById('email-template-row-template').innerHTML, {noEscape: true});
                    $('.email-template-list').append(handleBarTemplate(templateData));
                }

                $('.waiting').removeClass('waiting');
            },

            showGeneralError(error) {
                $('.email-templates-container').prepend(
                    '<div class="error-box text-center mb-3">' +
                    '<p class="error mb-0">' + error + '</p>' +
                    '</div>'
                )
            },

            getPageSourceQueryParameter() {
                return '?src=et';
            },

            addListeners: function() {
                var t = this;

                $('#email_templates').on('click touchstart', '.js-delete-template', function (e) {
                    e.preventDefault();
                    t.deleteTemplate(e);
                });

                $('#email_templates').on('click touchstart', '.add-item-link', function (e) {
                    e.preventDefault();
                    var href = _l('/settings/template/new/' + t.getPageSourceQueryParameter());
                    window.location.href = href;
                });

                $('#email_templates').on('click touchstart', '.make-template-default', function (e) {
                    e.preventDefault();
                    var id = $(this).closest('.email-template-row').data('id');
                    if (id) {
                        t.makeTemplateDefault(id);
                    }
                });

                $('#email_templates').on('click touchstart', '.moi.js-edit-template', function (e) {
                    e.preventDefault();
                    var id = $(this).closest('.email-template-row').data('id');
                    var href = _l('/settings/template/' + id + '/' + t.getPageSourceQueryParameter());
                    window.location.href = href;
                });

                $('#email_templates').on('click', '.js-menu-show-options', function (e) {
                    e.preventDefault();
                    var scope = $(this);

                    if (scope.hasClass('open')) {
                        scope.removeClass('open');
                    } else {
                        scope.addClass('open');

                        window.setTimeout(function (){
                            $('body').on('click.closemenu', function () {
                                scope.removeClass('open');
                                $('body').off('click.closemenu');
                                $('body').off('touchend.closemenu');
                            });
                            $('body').on('touchend.closemenu', function (e) {
                                $('body').off('click.closemenu');
                                $('body').off('touchend.closemenu');
                                scope.removeClass('open');
                            });
                        }, 10)
                    }
                });
            }
        };

        Object.assign(_this, instanceVars);
        return _this;
    };

    EmailTemplate().initialise();
}
